import React from 'react'
import store from './AppStore'

export const StoreContext = React.createContext(store);